module.exports = __webpack_public_path__ + "img/16_mark_h.e9c23170.png";